import { WSControl, WSField, WSForm } from "@wingspanhq/fe-component-library";
import { IAttributeDefinition } from "@wingspanhq/payments/dist/interfaces";

type Props = {
  definition: IAttributeDefinition;
  disabled?: boolean;
};

export const FieldBoolean: React.FC<Props> = props => {
  return (
    <WSField label={props.definition.name}>
      <WSForm.Field
        label=""
        name={props.definition.key}
        component={WSControl}
        componentProps={{
          type: "checkbox",
          label: props.definition.description,
          size: "S",
          disabled: props.disabled
        }}
      />
    </WSField>
  );
};
